import { AlphaCard, Button, HorizontalGrid, HorizontalStack, Icon, Link, Modal, Text, TextField, VerticalStack } from "@shopify/polaris";
import { useState } from "react";
import { saveInfluencerPrice, tryToDeletePrice, tryToUpdatePrice } from "../firebase";
import { Columns3Major, DeleteMinor, PlayCircleMajor } from "@shopify/polaris-icons";
import renderIcon from '../utils/price-icons'

export default function PriceModal({
  priceModalStage,
  setPriceModalStage,
  open,
  setOpen,
  newPriceItem,
  setNewPriceItem,
}) {
  const [priceLoading, setPriceLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);

  async function savePrice() {
    try {
      setPriceLoading(true);
      await saveInfluencerPrice(newPriceItem);
      setPriceModalStage(0);
      setNewPriceItem(null);
      setOpen(false);
    } catch (e) {
      console.error(e)
    } finally {
      setPriceLoading(false)
    }
  }

  function selectPriceTemplate(type) {
    switch (type) {
      case '30secMention':
        setNewPriceItem({
          type,
          title: '30 Second Short',
          piecesOfContent: 1,
          price: 100,
          deliveryTime: 7,
          revisions: 1
        });
        break;
      case '1minMention':
        setNewPriceItem({
          type,
          title: '1 Minute Short',
          piecesOfContent: 1,
          price: 150,
          deliveryTime: 7,
          revisions: 1
        });
        break;
      case '3shortBundle':
        setNewPriceItem({
          type,
          title: '3 Short Bundle',
          piecesOfContent: 3,
          price: 250,
          deliveryTime: 7,
          revisions: 1
        });
        break;
      case 'custom':
        setNewPriceItem({
          type,
          title: '',
          piecesOfContent: 1,
          price: 100,
          deliveryTime: 7,
          revisions: 1
        });
        break;
      default:
        break;
    }
    setPriceModalStage(1);
  }

  let modalStageContent;
  if (priceModalStage === 0) {
    modalStageContent = (
      <VerticalStack gap="2">
        <Text variant="headingLg">Starter Templates</Text>
        <HorizontalGrid columns={{ xs: "2", md: "3" }} gap="6">
          <Link removeUnderline onClick={() => selectPriceTemplate('30secMention')}>
            <AlphaCard >
              <VerticalStack inlineAlign="center" gap="1">
                {renderIcon('30secMention', 'interactive')}
                <Text variant="headingSm">
                  30 Second Short
                </Text>
              </VerticalStack>
            </AlphaCard>
          </Link>
          <Link removeUnderline onClick={() => selectPriceTemplate('1minMention')}>
            <AlphaCard >
              <VerticalStack inlineAlign="center" gap="1">
                {renderIcon('1minMention', 'interactive')}
                <Text variant="headingSm">
                  1 Minute Short
                </Text>
              </VerticalStack>
            </AlphaCard>
          </Link>
          <Link removeUnderline onClick={() => selectPriceTemplate('3shortBundle')}>
            <AlphaCard >
              <VerticalStack inlineAlign="center" gap="1">
                {renderIcon('3shortBundle', 'interactive')}
                <Text variant="headingSm">
                  3 Short Bundle
                </Text>
              </VerticalStack>
            </AlphaCard>
          </Link>
          <Link removeUnderline onClick={() => selectPriceTemplate('custom')}>
            <AlphaCard >
              <VerticalStack inlineAlign="center" gap="1">
                {renderIcon('youtubeShort', 'interactive')}
                <Text variant="headingSm">
                  Custom
                </Text>
              </VerticalStack>
            </AlphaCard>
          </Link>
        </HorizontalGrid>
      </VerticalStack>
    )
  } else {
    modalStageContent = (
      <VerticalStack gap="4">
        <AlphaCard background="bg-subdued">
          <VerticalStack gap="2">
            <TextField label="Title" value={newPriceItem.title} onChange={(value) => setNewPriceItem({ ...newPriceItem, title: value })} maxLength={40} />
            <HorizontalGrid gap="2" columns={{ xs: "1", md: "2" }} alignItems="end">
              <TextField prefix="$" label="Price" value={newPriceItem.price} onChange={(value) => setNewPriceItem({ ...newPriceItem, price: value })} type="currency" maxLength={6} />
              <VerticalStack inlineAlign="center">
                <Text variant="bodyMd">You will receive ${Math.floor(newPriceItem.price * .92)} </Text>
                <Text variant="bodySm" color="subdued">After 8% Fees</Text>
              </VerticalStack>
            </HorizontalGrid>
          </VerticalStack>
        </AlphaCard>
        {
          /*
*
        <TextField label="Quantity" value={newPriceItem.quantity} onChange={(value) => setNewPriceItem({ ...newPriceItem, quantity: value })} />
*/
        }
        <AlphaCard background="bg-subdued">
          <HorizontalGrid gap="2" columns={{ xs: "1", md: "3" }}>
            <TextField
              label="Pieces of Content"
              value={newPriceItem.piecesOfContent}
              prefix={newPriceItem.piecesOfContent > 1 ? '🎥' : '🎵'}
              onChange={(value) => setNewPriceItem({ ...newPriceItem, piecesOfContent: value })}
              type="number"
              min={1}
              max={2} />
            <TextField
              label="Deadline"
              value={newPriceItem.deliveryTime}
              prefix="🚚"
              onChange={(value) => setNewPriceItem({ ...newPriceItem, deliveryTime: value })}
              type="number"
              min={1}
              max={14}
              helpText="including delivery time. starts when you accept"
              suffix="days"
            />
            <TextField
              label="# of Revisions"
              value={newPriceItem.revisions}
              prefix="🔁"
              onChange={(value) => setNewPriceItem({ ...newPriceItem, revisions: value })}
              type="number"
              min={1}
              max={14}
            />
          </HorizontalGrid>
        </AlphaCard>
      </VerticalStack>
    )
  }

  const editPrimaryAction = {
    content: 'Save Changes',
    loading: saveLoading,
    disabled: !newPriceItem || newPriceItem.price > 100000 || newPriceItem.title === '' || !newPriceItem.piecesOfContent || !newPriceItem.revisions || !newPriceItem.deliveryTime,
    onAction: async () => {
      try {
        setSaveLoading(true)
        await tryToUpdatePrice(newPriceItem.id, newPriceItem);
        setOpen(false)
        setPriceModalStage(0)
      } catch (e) {
        alert(e.message)
      } finally {
        setSaveLoading(false)
      }
    }
  }
  const editSecondaryActions = [
    {
      content: 'Cancel',
      onAction: () => {
        setOpen(false)
        setPriceModalStage(0)
      },
    },
    {
      content: 'Delete',
      destructive: true,
      loading: deleteLoading,
      onAction: async () => {
        try {
          setDeleteLoading(true)
          await tryToDeletePrice(newPriceItem.id);
          setOpen(false)
          setPriceModalStage(0)
        } catch (e) {
          alert(e.message)
        } finally {
          setDeleteLoading(false)
        }
      }
    },
  ]

  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false)
        setPriceModalStage(0)
      }}
      title="Create a New Price"
      primaryAction={priceModalStage !== 2 ? {
        content: 'Save Price',
        onAction: savePrice,
        disabled: !newPriceItem || newPriceItem.price > 100000 || newPriceItem.title === '' || !newPriceItem.deliveryTime || !newPriceItem.revisions || !newPriceItem.piecesOfContent,
        loading: priceLoading
      } : editPrimaryAction}
      secondaryActions={priceModalStage !== 2 ? [
        {
          content: 'Cancel',
          onAction: () => {
            setOpen(false)
            setPriceModalStage(0)
            setOpen(false);
          },
        },
      ] : editSecondaryActions}
    >
      <Modal.Section>
        {modalStageContent}
      </Modal.Section>
    </Modal>
  )
}
